// signinbutton.js
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  FormGroup,
  FormControl,
  Checkbox,
  Button,
  Modal
} from 'react-bootstrap';
import { connect } from 'react-redux';

import { login } from '../../../utils/apputils';
import { users } from '../../../store/actions';
import logo from '../../../static/images/logo-countpicula-dark.png';
import iconTip from '../../../static/images/icon-tip.svg';
import Spinner from '../../Spinner/Spinner.js';

const mapStateToProps = state => ({
  status: state.users.status
});

class SignInForm_Class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      remember: false
    };
  }

  onChange = ({ target: { id, checked, value } }) => {
    let val = id === 'remember' ? checked : value;
    this.setState({
      [id]: val
    });
  };

  onSubmit = e => {
    e.preventDefault();
    let { email, password, remember } = this.state;
    const { dispatch } = this.props;
    // Need to update this to the async one
    login(email, password, remember, dispatch);
  };

  handleClose = () => {
    const { dispatch } = this.props;
    dispatch(users.logout());
  };

  render() {
    const { status } = this.props;
    return (
      <form onSubmit={this.onSubmit}>
        <div className="tint-box">
          <FormGroup controlId="email">
            <FormControl
              type="email"
              value={this.state.email}
              placeholder="Email address"
              onChange={this.onChange}
              required
            />
            <FormControl.Feedback />
          </FormGroup>
          <FormGroup controlId="password">
            <FormControl
              type="password"
              value={this.state.password}
              placeholder="Password"
              onChange={this.onChange}
              required
            />
          </FormGroup>
        </div>
        <Checkbox id="remember" onChange={this.onChange}>
          Remember me on this computer
        </Checkbox>

        {status !== users.types.LOGGING_IN && (
          <div className="footer-buttons">
            <Button
              type="button"
              onClick={this.handleClose}
              className="btn-bevel"
            >
              Cancel
            </Button>
            <Button bsStyle="primary" type="submit" className="btn-bevel">
              Log in
            </Button>
          </div>
        )}
        {status === users.types.LOGIN_FAILED && (
          <span className="error"> Incorrect email or password</span>
        )}
        {status === users.types.LOGGING_IN && <Spinner type="regular" />}
      </form>
    );
  }
}
const SignInForm = connect(mapStateToProps)(SignInForm_Class);

class SignInButton extends Component {
  handleClose = () => {
    const { dispatch } = this.props;
    dispatch(users.logout());
  };

  handleShow = () => {
    const { dispatch } = this.props;
    dispatch(users.show_login());
  };

  handleForgotten = () => {
    const { dispatch } = this.props;
    dispatch(users.prompt_recovery_email());
  };

  render() {
    const { status } = this.props;
    const show = [
      users.types.SHOW_LOGIN,
      users.types.LOGGING_IN,
      users.types.LOGIN_FAILED
    ].includes(status);

    return (
      <React.Fragment>
        <Button
          bsStyle="primary"
          className="btn btn-primary"
          onClick={this.handleShow}
        >
          Log in
        </Button>
        <Modal show={show} onHide={this.handleClose} bsSize="large">
          <Modal.Header closeButton>
            <h2 className="modal-title" id="m_registerLabel">
              <span>You again?</span>
            </h2>
            <img
              className="logo-img"
              src={logo}
              width="117"
              height="75"
              alt=""
            />
          </Modal.Header>
          <Modal.Body>
            <h3 className="bar-header">Log in to your Count Picula account</h3>
            <SignInForm close={this.handleClose} />
          </Modal.Body>
          <div className="modal-footer modal-footer--tip">
            <div>
              <img className="tip-icon" src={iconTip} width="310" alt="" />
              <div className="tip-text">
                <span>Forgotten your password?</span>
                <Link
                  id="forgot-password"
                  to="/"
                  onClick={this.handleForgotten}
                >
                  Click here to reset it.
                </Link>
              </div>
            </div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps)(SignInButton);



// WEBPACK FOOTER //
// ./src/comps/Navbar/components/SignInButton.js